export default __webpack_public_path__ + "static/media/WF.31d482ac.ico";